import React, { useRef } from 'react';
import './Categories.scss';

function Categories(props) {
  const currentSelected = useRef();
  const handleClick = () => {
    if ((props.currentCategoryEnded || (props.ended && props.categoryIndex > props.index))) {
      props.setCategory();
    }
    else {
      let el = document.querySelector(`.categories.${props.currentCategory}`);
      if (el) {
        if(props.getLentgh(props.currentCategory) + 1 <= 3){
          el.querySelector(`.selected-${props.getLentgh(props.currentCategory) + 1}`).classList.add("focus");
          setTimeout(() => {
            el.querySelector(`.selected-${props.getLentgh(props.currentCategory) + 1}`).classList.remove("focus");
          }, 400);
        }
      }
    }
  }
  return (
    <div className={`categories ${props.category} ${props.currentCategory !== props.category && props.selected === 0 ? "gray" : ""}`} onClick={handleClick}>
      <div className="category">
        <span>{props.title}</span>
        <div className="choosed">
          <div className={`selected-1 one ${props.selected > 0 ? "active" : ""}`}></div>
          <div className={`selected-2 two ${props.selected > 1 ? "active" : ""}`}></div>
          <div className={`selected-3 three ${props.selected > 2 ? "active" : ""}`}></div>
        </div>
      </div>
    </div>
  );
}

export default Categories;
